import {Component, inject, Input} from '@angular/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgIf} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {GatewayOrder} from "../../../model/gateway/gatewayOrder";
import {GatewayOrderService} from "../../../service/gateway.order.service";

const ORDER_NAME_MAX_CHARS = 100;

@Component({
  selector: 'app-gateway-order-edit-name',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle
  ],
  template: `
    <h2 mat-dialog-title style="margin-left: 10%;">Update Gateway Order Name</h2>
    <form [formGroup]="editGatewayOrderForm" class="gateway-order-edit-name-form">
      <div class="mb-3" style="justify-content: left">
        <label for="orderName" class="form-label">Gateway Order Name*</label>
        <input id="orderName" class="form-control" type="text" autocomplete="off"
               formControlName="orderName" [maxlength]="ORDER_NAME_MAX_CHARS" required>
        <div *ngIf="orderName?.invalid && (orderName?.dirty || orderName?.touched)" class="alert alert-danger">
          <div *ngIf="orderName?.errors?.['required']">Gateway Order Name is required.</div>
          <div *ngIf="orderName?.errors?.['maxlength']">Gateway Order Name must be 100 characters or fewer.</div>
        </div>
      </div>
    </form>
    <mat-dialog-actions style="justify-content: center">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button [disabled]="editGatewayOrderForm.invalid" (click)="submit()">Update</button>
    </mat-dialog-actions>
  `,
  styleUrl: './gateway-order-edit-name.component.css'
})
export class GatewayOrderEditNameComponent {

  @Input() gatewayOrder!: GatewayOrder;

  private formBuilder = inject(FormBuilder);
  private gatewayOrderService = inject(GatewayOrderService);
  public dialogRef = inject(MatDialogRef<GatewayOrderEditNameComponent>);

  editGatewayOrderForm: FormGroup = this.createForm();

  public setGatewayOrder(gatewayOrder: GatewayOrder) {
    this.gatewayOrder = gatewayOrder;
    this.orderName?.setValue(gatewayOrder.orderName);
  }

  submit() {
    const orderName = this.orderName?.value?.trim();
    if (this.gatewayOrder && orderName) {
      this.gatewayOrderService.updateOrderName(this.gatewayOrder.gatewayOrderId, orderName).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }

  get orderName() {
    return this.editGatewayOrderForm.get('orderName');
  }

  private createForm(): FormGroup {
    return this.formBuilder.group({
      orderName: [null, [Validators.required, Validators.maxLength(ORDER_NAME_MAX_CHARS)]]
    });
  }

  protected readonly ORDER_NAME_MAX_CHARS = ORDER_NAME_MAX_CHARS;
}
